import { render } from "./WarehouseDashboardWidget.vue?vue&type=template&id=25e53875&scoped=true&ts=true"
import script from "./WarehouseDashboardWidget.vue?vue&type=script&lang=ts"
export * from "./WarehouseDashboardWidget.vue?vue&type=script&lang=ts"

import "./WarehouseDashboardWidget.vue?vue&type=style&index=0&id=25e53875&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e53875"]])

export default __exports__